/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { HistoryPropertyChange } from './HistoryPropertyChange';
import {
    HistoryPropertyChangeFromJSON,
    HistoryPropertyChangeFromJSONTyped,
    HistoryPropertyChangeToJSON,
} from './HistoryPropertyChange';
import type { ChangesGroupDtoType } from './ChangesGroupDtoType';
import {
    ChangesGroupDtoTypeFromJSON,
    ChangesGroupDtoTypeFromJSONTyped,
    ChangesGroupDtoTypeToJSON,
} from './ChangesGroupDtoType';

/**
 * 
 * @export
 * @interface ChangesGroupDto
 */
export interface ChangesGroupDto {
    /**
     * 
     * @type {ChangesGroupDtoType}
     * @memberof ChangesGroupDto
     */
    type?: ChangesGroupDtoType | null;
    /**
     * 
     * @type {Array<HistoryPropertyChange>}
     * @memberof ChangesGroupDto
     */
    changes?: Array<HistoryPropertyChange> | null;
    /**
     * 
     * @type {string}
     * @memberof ChangesGroupDto
     */
    uniqueName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangesGroupDto
     */
    $type?: ChangesGroupDtoTypeEnum;
}


/**
 * @export
 */
export const ChangesGroupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedEntityHistoryChangesGroupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.EntityHistory.ChangesGroupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ChangesGroupDtoTypeEnum = typeof ChangesGroupDtoTypeEnum[keyof typeof ChangesGroupDtoTypeEnum];



/**
 * Check if a given object implements the ChangesGroupDto interface.
 */
export function instanceOfChangesGroupDto(value?: unknown): value is ChangesGroupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ChangesGroupDtoTypeEnum)[0];
}

export function ChangesGroupDtoFromJSON(json: any): ChangesGroupDto {
    return ChangesGroupDtoFromJSONTyped(json, false);
}

export function ChangesGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangesGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : ChangesGroupDtoTypeFromJSON(json['type']),
        'changes': json['changes'] == null ? undefined : ((json['changes'] as Array<any>).map(HistoryPropertyChangeFromJSON)),
        'uniqueName': json['uniqueName'] == null ? undefined : json['uniqueName'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ChangesGroupDtoToJSON(value?: ChangesGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'type': ChangesGroupDtoTypeToJSON(value['type']),
        'changes': value['changes'] == null ? undefined : ((value['changes'] as Array<any>).map(HistoryPropertyChangeToJSON)),
        'uniqueName': value['uniqueName'],
        '$type': value['$type'],
    });
}

